import { render, staticRenderFns } from "./AllDayEventDetail.vue?vue&type=template&id=2b1e5477&scoped=true"
import script from "./AllDayEventDetail.vue?vue&type=script&lang=js"
export * from "./AllDayEventDetail.vue?vue&type=script&lang=js"
import style0 from "./AllDayEventDetail.vue?vue&type=style&index=0&id=2b1e5477&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1e5477",
  null
  
)

export default component.exports